<template></template>

<script>
export default {
  data: function () {
    return {
      form: {
        subscription: "month",
        coupon: "",
      },

      discount: 0,
      invalidCode: false,
      subscriptions: JSON.parse(this.products),
    };
  },

  props: ["completeUrl", "couponUrl", "stripeKey", "rate", "products"],

  computed: {
    oldPrice: function () {
      var net = parseFloat(this.subscriptions[this.form.subscription].price);
      var total = net + (this.rate / 100) * net;
      return total.toFixed(2);
    },

    price: function () {
      var net = parseFloat(this.subscriptions[this.form.subscription].price);
      net = net - (net * parseFloat(this.discount)) / 100;
      var total = net + (this.rate / 100) * net;
      return total.toFixed(2);
    },
  },

  mounted() {
    let self = this;
    setTimeout(function () {
      self.stripe = Stripe(self.stripeKey);
      self.setUpStripePay();
    }, 3000);
  },

  methods: {
    /* Start Stripe functionality */
    setUpStripePay() {
      const stripe = Stripe(this.stripeKey);
      const elements = stripe.elements();

      const cardElement = elements.create("card", { hidePostalCode: true });
      cardElement.mount("#card_number");

      const selectSubscription = document.getElementById("subscription");
      const discountCode = document.getElementById("code");
      const cardName = document.getElementById("card_name");
      const country = document.getElementById("card_country");
      const cardButton = document.getElementById("card_button");
      const clientSecret = cardButton.dataset.secret;

      cardName.disabled = false;

      cardButton.addEventListener("click", async (e) => {
        cardButton.disabled = true;
        $("#paymentModal").modal({ backdrop: "static", keyboard: false });

        const billingDetails = {
          name: cardName.value,
          address: {
            country: country.value,
          },
        };

        const { setupIntent, error } = await stripe.confirmCardSetup(
          clientSecret,
          {
            payment_method: {
              card: cardElement,
              billing_details: billingDetails,
            },
          }
        );

        if (error) {
          console.log(error);
          document.getElementById("card_error").innerHTML = error.message;
          $("#paymentModal").modal("hide");
        } else {
          document.getElementById("card_error").innerHTML = "";

          let postData = {};
          postData.payment_id = setupIntent.payment_method;
          postData.billing_details = billingDetails;
          postData.subscription = this.form.subscription;
          postData.code = this.form.code;

          axios
            .post(this.completeUrl, postData)
            .then((response) => {
              this.handleServerResponse(response);
            })
            .catch((error) => {
              console.log(error);
              $("#paymentModal").modal("hide");
              document.getElementById("card_error").innerHTML =
                error.response.data;
            });
        }

        cardButton.disabled = false;
      });

      cardName.addEventListener("keyup", (event) => {
        this.checkInput(cardName, cardButton);
      });

      discountCode.addEventListener("keyup", (event) => {
        this.discount = 0;
      });

      selectSubscription.addEventListener("change", (event) => {
        this.form.code = "";
        this.discount = 0;
      });
    },

    handleServerResponse(response) {
      $("#paymentModal").modal("hide");
      if (response.data.error) {
        document.getElementById("card_error").innerHTML = response.data.message;
      } else if (response.data.requires_action) {
        // Use Stripe.js to handle required card action
        window.location = response.data.redirectUrl;
      } else {
        // Show success message
        window.location = response.data.redirectUrl;
      }
    },

    checkInput(cardName, cardButton) {
      if (cardName.value != "") {
        cardButton.disabled = false;
      } else {
        cardButton.disabled = true;
      }
    },

    checkCoupon() {
      let postData = {};
      postData.code = this.form.code;
      postData.subscription = this.form.subscription;

      axios
        .post(this.couponUrl, postData)
        .then((response) => {
          if (response.data.valid) {
            this.discount = response.data.amount;
            this.invalidCode = false;
          } else {
            this.discount = 0;
            this.invalidCode = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
